export const CHANGE_VARIATIONS_VERSION = 'CHANGE_VARIATIONS_VERSION';
